(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["after-add-recommendations"] && !Shopify.designMode) return;
  try {
    function bmsReadJSON(element, fallback = []) {
  try { return JSON.parse(element?.textContent || 'null') ?? fallback; } catch { return fallback; }
}
function bmsInches(value) {
  const text = String(value).trim().replace(/^(width|depth)\s*:\s*/i, '');
  const match = text.match(/^(\d+(?:\.\d+)?)(?:[ -](\d+)\/(\d+))?\s*(?:["″]|in(?:ch(?:es)?)?)?\s*$/i);
  if (!match) return null;
  const number = Number(match[1]) + (match[2] ? Number(match[2]) / Number(match[3]) : 0);
  return Number.isFinite(number) && number > 0 ? number : null;
}
function bmsShelfSize(values, names) {
  const widthIndex = names.findIndex(name => /^width$/i.test(name));
  const depthIndex = names.findIndex(name => /^depth$/i.test(name));
  let size;
  if (widthIndex >= 0 && depthIndex >= 0) {
    size = [bmsInches(values[widthIndex]), bmsInches(values[depthIndex])];
  } else {
    const sizeIndex = names.findIndex(name => /size|dimension/i.test(name));
    if (sizeIndex < 0 || !values[sizeIndex]) return null;
    const parts = String(values[sizeIndex]).split(/\s+[–—]\s+/)[0].split(/\s*[x×]\s*/i);
    if (parts.length < 2 || parts.length > 3) return null;
    size = [bmsInches(parts[0]), bmsInches(parts[1])];
  }
  return size.every(value => value !== null) ? size : null;
}
function bmsMatchingShelf(currentOptions, optionNames, variants, accessoryNames) {
  const size = bmsShelfSize(currentOptions, optionNames);
  if (!size) return null;
  return variants.find(variant => {
    if (!variant.available) return false;
    const candidate = bmsShelfSize(variant.options || [], accessoryNames);
    return candidate && candidate[0] === size[0] && candidate[1] === size[1];
  }) || null;
}
function bmsConfigureShelf(owner, currentOptions) {
  const item = owner.querySelector('[data-bms-recommendation-kind="accessory"]');
  if (!item) return false;
  const sourceNames = JSON.parse(owner.dataset.optionNames || '[]');
  const accessoryNames = JSON.parse(item.dataset.optionNames || '[]');
  const variants = bmsReadJSON(item.querySelector('[data-bms-accessory-variants]'));
  const variant = bmsMatchingShelf(currentOptions, sourceNames, variants, accessoryNames);
  item.hidden = !variant;
  if (!variant) return false;
  const url = new URL(item.dataset.bmsProductUrl, window.location.origin);
  url.searchParams.set('variant', variant.id);
  item.querySelectorAll('a[href]').forEach(link => { link.href = url.href; });
  const input = item.querySelector('input[name="id"]');
  if (input) input.value = variant.id;
  const quantity = item.querySelector('input[name="quantity"]');
  if (quantity) {
    const rule = variant.quantity_rule || {};
    quantity.min = rule.min || 1;
    quantity.step = rule.increment || 1;
    if (rule.max) quantity.max = rule.max; else quantity.removeAttribute('max');
    quantity.value = quantity.min;
  }
  const size = bmsShelfSize(variant.options, accessoryNames);
  const label = item.querySelector('[data-bms-exact-match]');
  if (label) { label.textContent = `${owner.dataset.exactSizeLabel}: ${size.join(' × ')} in.`; label.hidden = false; }
  const money = new Intl.NumberFormat(owner.dataset.locale || 'en-US', {style:'currency', currency:owner.dataset.currency || 'USD'}).format(variant.price / 100);
  item.querySelectorAll('.card-information .price').forEach(price => { price.textContent = money; });
  item.dataset.matchedVariantId = variant.id;
  return true;
}
if (!customElements.get('after-add-recommendations')) {
  customElements.define('after-add-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.currentOptions = JSON.parse(this.dataset.currentOptions || '[]');
      this.sourceVariants = bmsReadJSON(this.querySelector('[data-bms-source-variants]'));
      this.variantIds = (this.dataset.variantIds || '').split(',');
      this.querySelectorAll('[data-bms-after-add-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-bms-quantity-change]');
        if (!button) return;
        const input = button.closest('.bms-recommendation-purchase').querySelector('[name="quantity"]');
        if (!input) return;
        Number(button.dataset.bmsQuantityChange) > 0 ? input.stepUp() : input.stepDown();
        input.dispatchEvent(new Event('change', {bubbles:true}));
      });
      bmsConfigureShelf(this, this.currentOptions);
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (!event.data?.variant || event.data.sectionId !== this.dataset.sectionId) return;
        this.currentOptions = event.data.variant.options;
        if (!bmsConfigureShelf(this, this.currentOptions)) this.dialog.close();
      });
      this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (event.source !== 'product-form') return;
        const addedId = String(event.productVariantId);
        if (!this.variantIds.includes(addedId)) {
          if (addedId === this.querySelector('[data-matched-variant-id]')?.dataset.matchedVariantId) this.dialog.close();
          return;
        }
        const added = this.sourceVariants.find(variant => String(variant.id) === addedId);
        const addedOptions = added?.options || this.currentOptions;
        if (!bmsConfigureShelf(this, addedOptions)) return;
        window.clearTimeout(this.openTimer);
        this.openTimer = window.setTimeout(() => { if (this.isConnected && !this.dialog.open) this.dialog.showModal(); }, 500);
      });
    }
    disconnectedCallback() {
      window.clearTimeout(this.openTimer);
      this.variantUnsubscriber?.();
      this.cartUnsubscriber?.();
    }
  });
}
if (!customElements.get('tagged-product-recommendations')) {
  customElements.define('tagged-product-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.currentOptions = JSON.parse(this.dataset.currentOptions || '[]');
      this.variantIds = (this.dataset.variantIds || '').split(',');
      const refresh = () => {
        const accessory = bmsConfigureShelf(this, this.currentOptions);
        const units = this.querySelectorAll('[data-bms-recommendation-kind="unit"]');
        this.hidden = !accessory && units.length === 0;
      };
      refresh();
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (!event.data?.variant || !this.variantIds.includes(String(event.data.variant.id))) return;
        this.currentOptions = event.data.variant.options;
        refresh();
      });
    }
    disconnectedCallback() { this.variantUnsubscriber?.(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bms-video-facade"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bms-video-facade')) {
    customElements.define('bms-video-facade', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const poster = this.querySelector('.bms-video-facade__poster');
        if (!poster) return;
        poster.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const source = this.querySelector('template')?.content.querySelector('iframe');
          if (!source) return;
          event.preventDefault();
          if (this.hasAttribute('loaded')) return;
          const iframe = source.cloneNode(true);
          const url = new URL(iframe.src, window.location.href);
          url.searchParams.set('autoplay', '1');
          iframe.src = url.href;
          if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
          this.setAttribute('loaded', '');
          this.appendChild(iframe);
          poster.remove();
          iframe.focus();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
